__turbopack_context__.v({
  "carouselArrows": "videogroup-module-scss-module__IrdLza__carouselArrows",
  "modalNextArrow": "videogroup-module-scss-module__IrdLza__modalNextArrow",
  "modalPrevArrow": "videogroup-module-scss-module__IrdLza__modalPrevArrow",
  "modalSlider": "videogroup-module-scss-module__IrdLza__modalSlider",
  "nextArrow": "videogroup-module-scss-module__IrdLza__nextArrow",
  "prevArrow": "videogroup-module-scss-module__IrdLza__prevArrow",
  "slider": "videogroup-module-scss-module__IrdLza__slider",
  "sliderTrack": "videogroup-module-scss-module__IrdLza__sliderTrack",
  "splideSlideItem": "videogroup-module-scss-module__IrdLza__splideSlideItem",
  "videoContainer": "videogroup-module-scss-module__IrdLza__videoContainer",
  "videoModal": "videogroup-module-scss-module__IrdLza__videoModal",
});
